import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import ServicesMenu from './ServicesMenu.js';
import MobileMenu from './MobileMenu.js';
import AuthMenu from './AuthMenu.js';
import MenuControls from './MenuControls.js';
import Container from '@material-ui/core/Container';
import logo from '../../assets/nav-logo.svg';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    zIndex: 998,
    width: '100%',
    backgroundColor: theme.palette.common.white,
    boxShadow: 'none',
  },
  appBar: {
    boxShadow: 'none',
    borderBottom: 'none',
    backgroundColor: 'transparent',
    padding: '0 2rem',
    [theme.breakpoints.down('sm')]: {
      padding: '0 1rem',
    },
  },
  toolbar: {
    flexGrow: 1,
    padding: '0 1rem',
    height: '6.25rem',
    width: '100%',
  },
  logo: {
    width: '17rem',
    display: 'block',
    marginRight: '1.5rem',
  },
}));

const NavMenu = () => {
  const classes = useStyles();
  const [showServicesMenu, setShowServicesMenu] = React.useState(false);
  const [showMobileMenu, setShowMobileMenu] = React.useState(false);
  const [authMenu, setAuthMenu] = React.useState(null);

  const toggleServicesMenu = () => {
    if (authMenu !== null) {
      setAuthMenu(null);
    }
    setShowServicesMenu(!showServicesMenu);
  };

  const closeServicesMenu = () => {
    setShowServicesMenu(false);
    // set focus per https://www.w3.org/TR/wai-aria-practices/examples/menubar/menubar-1/menubar-1.html
    document.getElementById('nav-services-button').focus();
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const toggleAuthMenu = (value) => {
    if (showServicesMenu === true) {
      setShowServicesMenu(false);
    }
    if (authMenu !== value) {
      setAuthMenu(value);
    } else {
      setAuthMenu(null);
    }
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Container maxWidth="lg" disableGutters={true}>
          <Toolbar className={classes.toolbar}>
            <Link to="/" className={classes.logoText}>
              <img src={logo} alt="clickability-logo" className={classes.logo} />
            </Link>
            <MenuControls
              showServicesMenu={showServicesMenu}
              toggleServicesMenu={toggleServicesMenu}
              toggleMobileMenu={toggleMobileMenu}
              toggleAuthMenu={toggleAuthMenu}
            />
          </Toolbar>
        </Container>
      </AppBar>
      {showServicesMenu ? <ServicesMenu closeServicesMenu={closeServicesMenu} /> : null}
      {showMobileMenu ? <MobileMenu authMenu={authMenu} setAuthMenu={setAuthMenu} /> : null}
      {authMenu !== null && showMobileMenu === false ? (<AuthMenu authMenu={authMenu} setAuthMenu={setAuthMenu} />) : null}
    </div>
  );
};

export default NavMenu;
